(() => {
  'use strict';
  const bound = new WeakSet();
  const selector = 'dialog.ceika-cart-modal,dialog.coil-native-dialog,dialog.ceika-preview-cart';
  const spareScript = document.currentScript?.dataset.spareEnquiryScript;
  let spareRequest;
  function scanSpares(mount) {
    if (!mount.querySelector('[data-ceika-spare-enquiry]')) return;
    if (window.CeikaSpareEnquiries) { window.CeikaSpareEnquiries.scan(); return; }
    if (!spareScript) return;
    spareRequest ||= new Promise(resolve => {
      const script = document.createElement('script');
      script.src = spareScript;
      script.onload = resolve;
      script.onerror = resolve;
      document.head.append(script);
    });
    spareRequest.then(() => window.CeikaSpareEnquiries?.scan());
  }
  function bind(dialog) {
    if (bound.has(dialog)) return;
    bound.add(dialog);
    let request;
    const mount = dialog.querySelector('.ceika-cart-modal__suggestions') || document.createElement('div');
    mount.className = 'ceika-cart-modal__suggestions';
    mount.hidden = true;
    const footer = dialog.querySelector('.ceika-cart-modal__footer,.ceika-preview-cart__footer');
    if (!mount.parentElement) {
      const body = dialog.querySelector('.coil-native-dialog__body,.ceika-preview-cart__body');
      if (body) body.append(mount);
      else if (footer) footer.before(mount);
      else dialog.append(mount);
    }
    async function update() {
      request?.abort();
      mount.hidden = true;
      mount.replaceChildren();
      if (!dialog.open) return;
      const root = window.Shopify?.routes?.root || '/';
      if (!/^\/(?:[a-z0-9]+(?:-[a-z0-9]+)*\/)*$/i.test(root)) return;
      const controller = new AbortController();
      request = controller;
      const url = new URL(root, location.origin);
      url.searchParams.set('section_id', 'ceika-cart-suggestions');
      const theme = window.Shopify?.theme;
      if (['unpublished', 'development'].includes(theme?.role) && /^\d+$/.test(String(theme.id))) url.searchParams.set('preview_theme_id', String(theme.id));
      try {
        const response = await fetch(url.href, {credentials: 'same-origin', cache: 'no-store', signal: controller.signal});
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-ceika-cart-suggestions-content]');
        if (!content || request !== controller || !dialog.open) return;
        content.querySelectorAll('script').forEach(script => script.remove());
        if (!content.querySelector('ceika-reviewed-offers,ceika-build-offer,[data-ceika-spare-enquiry]')) return;
        const heading = dialog.querySelector('.coil-native-dialog__build-heading,.ceika-preview-card__header');
        const first = dialog.querySelector('.coil-native-dialog__other-item,.ceika-preview-card');
        if (heading) heading.after(mount);
        else if (first) first.after(mount);
        else {
          const body = dialog.querySelector('.coil-native-dialog__body,.ceika-preview-cart__body');
          if (body) body.prepend(mount);
        }
        mount.replaceChildren(...Array.from(content.childNodes, node => document.importNode(node, true)));
        mount.hidden = false;
        scanSpares(mount);
      } catch (error) {
        if (error.name !== 'AbortError') mount.hidden = true;
      }
    }
    const observer = new MutationObserver(update);
    observer.observe(dialog, {attributes: true, attributeFilter: ['open']});
    dialog.addEventListener('ceika:cart-rendered', update);
    if (dialog.open) update();
  }
  function scan(scope = document) {
    if (scope.matches?.(selector)) bind(scope);
    scope.querySelectorAll?.(selector).forEach(bind);
  }
  function start() {
    scan();
    const observer = new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) scan(node);
    });
    observer.observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
